import { translator } from "./translator";

export const departmentOptions = [
  { value: "pro", label: translator["pro"] },
  { value: "life", label: translator["life"] },
];

export const courseOptions = [
  { value: "general", label: translator["general"] },
  { value: "special", label: translator["special"] },
];
